import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    //margin: '0 0 24px',
    marginTop: theme.spacing(1),
    fontSize: 25,
    color: 'black',
  },
  paper: {
    //marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    width: '30%',
  },
  formControl: {
    width: '100%',
  },
  link: {
    //alignItems: 'flex-grow',
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-end',
  },
  margin: {
    margin: theme.spacing(1),
  },
  footnote: {
    opacity: 0.5,
    margin: theme.spacing(1),
  },
}));
